import axios from 'axios';
import { severity } from './severity';
import SnackbarStore from '../store/SnackbarStore';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  timeout: 60000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    // config.headers.ContentType = 'application/json';
    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers.Accept = config.url.includes('UploadDocumentToS3') ? 'text/plain' : 'application/json';
    config.headers['Content-Type'] = config.url.includes('UploadDocumentToS3')
      ? 'multipart/form-data'
      : 'application/json';
    config.headers.Authorization = `Bearer ${userAccessToken()}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    SnackbarStore.toggleSnackbar(true, severity.error, error.message);
    if (error?.response?.status === 401) {
      localStorage.removeItem('authentication');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

const userAccessToken = () => {
  const authentication = localStorage.getItem('authentication');
  return authentication ? JSON.parse(authentication).token : null;
};

export default axiosInstance;
